import React from 'react';
import './Loader.css';
import PropTypes from 'prop-types';
import { translate } from '../../utils/translations';

const Loader = props => (
    <p className="loader-wrapper">{translate(props.language, 'Loading')}...</p>
);

Loader.propTypes = {
    language: PropTypes.string,
};

export default Loader;



// WEBPACK FOOTER //
// ./src/partials/Loader/Loader.js